import React from "react";
import "../../assets/style/CenteredLoading.css";

const CenteredLoading = () => {
  return (
    <div className="usa-loading-wrapper">
    
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="60"
        height="60"
        viewBox="0 0 200 200"
        className="loading-spinner"
      >
        <defs>
          <radialGradient id="a11" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
            <stop offset="0" stopColor="#2c7be5" />
            <stop offset=".3" stopColor="#2c7be5" stopOpacity=".9" />
            <stop offset=".6" stopColor="#2c7be5" stopOpacity=".6" />
            <stop offset=".8" stopColor="#2c7be5" stopOpacity=".3" />
            <stop offset="1" stopColor="#2c7be5" stopOpacity="0" />
          </radialGradient>
        </defs>
        <circle
          transformOrigin="center"
          fill="none"
          stroke="url(#a11)"
          strokeWidth="15"
          strokeLinecap="round"
          strokeDasharray="200 1000"
          strokeDashoffset="0"
          cx="100"
          cy="100"
          r="70"
        >
          <animateTransform
            type="rotate"
            attributeName="transform"
            calcMode="spline"
            dur="2s"
            values="0 100 100;360 100 100"
            keyTimes="0;1"
            keySplines="0.42 0 0.58 1"
            repeatCount="indefinite"
          />
        </circle>
        <circle
          transformOrigin="center"
          fill="none"
          opacity=".2"
          stroke="#2c7be5"
          strokeWidth="15"
          strokeLinecap="round"
          cx="100"
          cy="100"
          r="70"
        />
      </svg>
    </div>
  );
};

export default CenteredLoading;
